import { render, staticRenderFns } from "./AttachmentDraft.vue?vue&type=template&id=2a4b9552"
import script from "./AttachmentDraft.vue?vue&type=script&lang=js"
export * from "./AttachmentDraft.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDraft.vue?vue&type=style&index=0&id=2a4b9552&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports